import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import configurationClient from '@/axiosClients/configurationClient'

export const getCatalogDiagnostics = async ({ commit }, search = '') => {
    try {
        const { data: result } = await configurationClient.get(`/official-catalogs/diagnostics?search=${encodeURIComponent(search)}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
